import React from "react";
import "./FiltroServico.css";

const SERVICOS = [
  "Auditoria",
  "Audit. Patrimonial",
  "Governan\u00e7a",
  "Guarda Documental",
  "Planejamento Estrat\u00e9gico",
];

const FiltroServico = ({ valorSelecionado, onChange }) => {
  return (
    <section className="filtro-servico-container page-section-card">
      <div className="filtro-servico-header">
        <span className="filtro-label">Filtrar experiencia</span>
        <p>Selecione um modulo para destacar apenas os clientes relacionados a esse contexto.</p>
      </div>
      <div className="filtro-botoes">
        {SERVICOS.map((servico) => (
          <button
            key={servico}
            type="button"
            className={`filtro-botao ${valorSelecionado === servico ? "ativo" : ""}`}
            onClick={() => (valorSelecionado === servico ? onChange(null) : onChange(servico))}
          >
            {servico}
          </button>
        ))}
      </div>
    </section>
  );
};

export default FiltroServico;
